import { useTranslation } from "react-i18next"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"
import { GlobeIcon, GlobeIconActive } from "@/components/icons/GlobeIcon"

const FleetOverviewSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.FLEET_OVERVIEW}
      icon={GlobeIcon}
      activeIcon={GlobeIconActive}
      tooltipText={t("app.sidebar.fleetOverview")}
      className={className}
    />
  )
}

export default FleetOverviewSidebarButton
